// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var isKioskClientId = function (clientId, defaultClientId) {
    return clientId === "".concat(defaultClientId, "-kiosk");
};
export var getLogoutRedirectUrl = function (_a) {
    var redirectUrl = _a.redirectUrl, origin = _a.origin, pathname = _a.pathname, tenantId = _a.tenantId, eventId = _a.eventId, clientId = _a.clientId, defaultClientId = _a.defaultClientId, hasKioskQuery = _a.hasKioskQuery;
    if (redirectUrl) {
        return redirectUrl;
    }
    var isKiosk = isKioskClientId(clientId, defaultClientId) || (!clientId && hasKioskQuery);
    if (isKiosk) {
        return "".concat(origin, "/tenant/").concat(tenantId, "/event/").concat(eventId, "/login?kiosk");
    }
    var pathSegments = pathname.split("/");
    while (pathSegments.length > 5) {
        pathSegments.pop();
    }
    return origin + pathSegments.join("/");
};
